/**
 * Make payload API friendly
 * @param {*} data
 * @returns denormalised api friendly payload
 */
export function denormalisePartnerPaymentForm(formPayload) {
  let payload = {
    email: formPayload.email.value,
    addressee: formPayload.name.value,
    // If apartment is provided, add it to the address_1 field to be consistent with the shipbob address format
    address_1: formPayload.apartment.value
      ? `${formPayload.apartment.value} - ${formPayload.address.value}`
      : formPayload.address.value,
    city: formPayload.locality.value,
    post_code: formPayload.postal.value,
    phone: formPayload.phoneNumber.value || "",
    stateId: formPayload.stateId.value,
    countryId: formPayload.countryId.value,
    item_type: formPayload.itemType.value,
    item_id: formPayload.plan_id.value,
    delivery_method_id: formPayload.deliveryMethod.value,
    voucher_code: formPayload.voucher.value,
    no_headset_required: formPayload.headsetType.value === "none" ? 1 : 0,
    first_name: formPayload.name.value,
    user_id: formPayload.user_id.value,
    token: formPayload.token.value,
  };

  return payload;
}

export function denormaliseOnboardingPartnerPaymentForm(formPayload) {
  let payload = {
    email: formPayload.email.value,
    addressee: formPayload.name.value,
    // If apartment is provided, add it to the address_1 field to be consistent with the shipbob address format
    address_1: formPayload.apartment.value
      ? `${formPayload.apartment.value} - ${formPayload.address.value}`
      : formPayload.address.value,
    city: formPayload.locality.value,
    post_code: formPayload.postal.value,
    phone: formPayload.phoneNumber.value || "",
    stateId: formPayload.stateId.value,
    countryId: formPayload.countryId.value,
    item_type: formPayload.itemType.value,
    item_id: formPayload.plan_id.value,
    voucher_code: formPayload.voucher.value,
    no_headset_required: formPayload.headsetType.value === "none" ? 1 : 0,
    delivery_method_id: formPayload.deliveryMethod.value,
    first_name: formPayload.name.value,
    token: formPayload.token.value,
    plan_id: formPayload.plan_id.value,
  };

  return payload;
}
